export default [
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('@/views/admin'),
    children: [
      {
        path: 'user',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/users')
      },
      {
        path: 'user/:user',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/user')
      },
      {
        path: 'article',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/articles')
      },
      {
        path: 'block',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/blocks')
      },
      {
        path: 'block/:block',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/block')
      },
      {
        path: 'blog/article',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/blog/articles')
      },
      {
        path: 'blog/article/:blogArticle',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/blog/article')
      },
      {
        path: 'blog/category',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/blog/categories')
      },
      {
        path: 'blog/category/:blogCategory',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/blog/category')
      },
      {
        path: 'meta/skill',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/meta/skills')
      },
      {
        path: 'meta/skill/:skill',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/meta/skill')
      },
      {
        path: 'meta/skill-level',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/meta/skill-levels')
      },
      {
        path: 'meta/skill-level/:skillLevel',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/meta/skill-level')
      },
      {
        path: 'meta/domain',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/meta/domains')
      },
      {
        path: 'meta/domain/:domain',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/meta/domain')
      },
      {
        path: 'meta/category',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/meta/categories')
      },
      {
        path: 'meta/category/:category',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/meta/category')
      },
      {
        path: 'article/:article',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/article')
      },
      {
        path: 'opportunity',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/opportunities')
      },
      {
        path: 'opportunity/:opportunity',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/opportunity')
      },
      {
        path: 'opportunitytype',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/opportunitytypes')
      },
      {
        path: 'opportunitytype/:opportunityType',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/opportunitytype')
      },
      {
        path: 'profile',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/profiles')
      },
      {
        path: 'profile/:profile',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/profile')
      },
      {
        path: 'files',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/files')
      },
      {
        path: 'file/:file',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/file')
      },
      {
        path: 'metas',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/metas')
      },
      {
        path: 'meta/:meta',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/meta')
      },
      {
        path: 'company',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/companies')
      },
      {
        path: 'company/:company',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/company')
      },
      {
        path: 'contact',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/contacts')
      },
      {
        path: 'contact/:contact',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/contact')
      },
      {
        path: 'configuration/:configuration',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/configuration')
      },
      {
        path: 'configurations',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/configurations')
      },
      {
        path: 'community/:community',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/community')
      },
      {
        path: 'communities',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/communities')
      },
      {
        path: 'learn/sources',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/learn/sources')
      },
      {
        path: 'learn/source/:learnSource',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/learn/source')
      },
      {
        path: 'learn/source-groups',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/learn/source-groups')
      },
      {
        path: 'learn/source-group/:learnSourceGroup',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/learn/source-group')
      },
      {
        path: 'learn/suggestions',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/learn/suggestions')
      },
      {
        path: 'learn/suggestion/:learnSuggestion',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/learn/suggestion')
      },
      {
        path: 'learn/content-types',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/learn/content-types')
      },
      {
        path: 'learn/content-type/:learnContentType',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/learn/content-type')
      },
      {
        path: 'mail-messages',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/mail-messages')
      },
      {
        path: 'mail-message/:mailMessage',
        meta: { requiresAuth: true },
        component: () => import('@/views/admin/mail-message')
      },
      {
        path: '*',
        redirect: '/admin/opportunities'
      }
    ]
  },
  {
    path: '/image-browser',
    name: 'ImageBrowser',
    meta: { requiresAuth: true, layout: 'EmptyLayout' },
    component: () => import('@/views/admin/file-browser')
  }
]
